<template>
  <svg width="6.438" height="32">
    <path d="M5.92 19.234a10.32 10.32 0 0 0 0-6.454L1.94.691A.994.994 0 0 0 0 1.014V30.99a1 1 0 0 0 1.95.323Z" fill="currentColor"/>
  </svg>
</template>
